import React from 'react';
import { Field as FormField } from 'react-final-form';
import { FIELD_DESCRIPTION, FIELD_TEXT, FIELD_TEXTAREA, FIELD_TITLE } from 'constants/fields';
import { Editor } from 'UI/Inputs';
import { Icon } from '@haldor/ui';
import './Field.scss';

var Field = function Field(props) {
  var getFieldProps = function getFieldProps() {
    switch (props.type) {
      case FIELD_TEXT:
        return {
          component: 'input',
          type: 'text',
          name: props.name,
          placeholder: props.placeholder,
          disabled: props.disabled != null ? props.disabled : false,
          onBlur: props.onBlur != null ? props.onBlur : null
        };

      case FIELD_TEXTAREA:
        return {
          component: Editor,
          name: props.name,
          placeholder: props.placeholder,
          disabled: props.disabled != null ? props.disabled : false,
          onBlur: props.onBlur != null ? props.onBlur : null
        };

      default:
        return {};
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "form-row field"
  }, props.type == FIELD_TITLE ? /*#__PURE__*/React.createElement("div", {
    onClick: props.onLabelClick,
    className: "input-label"
  }, props.onLabelClick != null ? /*#__PURE__*/React.createElement(Icon, {
    name: "Chevron"
  }) : null, props.value) : null, props.type == FIELD_DESCRIPTION ? /*#__PURE__*/React.createElement("div", null, props.value) : null, props.type == FIELD_TEXT || props.type == FIELD_TEXTAREA ? /*#__PURE__*/React.createElement("div", {
    className: "input-field"
  }, /*#__PURE__*/React.createElement(FormField, getFieldProps())) : null);
};

export default Field;